import script from "./Solutions.vue?vue&type=script&setup=true&lang=js"
export * from "./Solutions.vue?vue&type=script&setup=true&lang=js"

import "./Solutions.vue?vue&type=style&index=0&id=b6b1ef10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6b1ef10"]])

export default __exports__